<template>
    <div class="chat-message" v-bind:class="classes">
        {{ message }}
    </div>
</template>
<script>
    export default {
        name: 'ChatMessage',
        props: [ 'sender', 'message', 'isError' ],
        computed: {
            classes: function() {
                var arr = [ this.sender + '-msg' ];
                if(this.isError) arr.push('error-msg');
                return arr;
            }
        }
    }
</script>
<style lang="stylus">
    .chat-message
        line-height: 1.2em
        margin: 0.5em
        text-align: left
        // &:before
        //     font-weight: bold
        &.avatar-msg
            color: #fff
            // content: "Holly: "
        &.user-msg
            font-weight: bold
            color: #e3f0b6
            // content: "You: "
        &.error-msg
            color: #dd554a
</style>